var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2995 1.51726C18.1459 0.479202 16.6777 -0.0917324 15.1571 0.0120739C13.5841 0.063977 12.1684 0.738718 11.1721 1.88059L1.52418 12.4169C0.47549 13.5588 -0.0488544 15.0121 0.00358002 16.5173C0.0560145 18.0225 0.737662 19.4757 1.89122 20.4619C2.93991 21.4481 4.30321 21.9671 5.71894 21.9671C5.8238 21.9671 5.92867 21.9671 6.03354 21.9671C7.55414 21.8633 8.96987 21.2404 10.0186 20.0986L19.6141 9.56225C20.6628 8.42038 21.1871 6.96709 21.1347 5.41C21.1347 3.90481 20.453 2.50342 19.2995 1.51726ZM13.8987 12.8321L8.44553 7.95325L12.7452 3.23007C13.4268 2.50342 14.3182 2.0882 15.262 2.0363C15.3144 2.0363 15.3669 2.0363 15.4193 2.0363C16.3107 2.0363 17.2021 2.39962 17.8837 3.02245C18.6178 3.6972 19.0373 4.57955 19.0897 5.5138C19.1422 6.49996 18.7751 7.43422 18.0935 8.16086L13.8987 12.8321Z",
    fill: "#002E6F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.7652626fc05f860453398744d7ab93a9.svg";
export { ForwardRef as ReactComponent };